<section class="w-full mt-3">
  <div class="sticky-header sticky top-16 z-[30] bg-white">
    <p class="text-2xl font-normal mt-[0.9rem]">Login Activity</p>

    <!-- Tabs -->
    <tui-tabs [(activeItemIndex)]="activeTabIndex" (activeItemIndexChange)="onTabChange($event)">
      <button tuiTab type="button" *ngFor="let tab of tabs">{{ tab }}</button>
    </tui-tabs>

    <!-- Past Logs Tab Search -->
    <div *ngIf="activeTabIndex === 0" class="mt-4">
      <search class="lg:w-full" tuiSearch style="padding-left: 0">
        <fieldset class="flex items-center gap-4 border-none">
          <div class="w-[300px]">
            <tui-textfield iconStart="@tui.search">
              <input
                [formControl]="searchControl"
                placeholder="Search by username or role"
                tuiTextfield
              />
            </tui-textfield>
          </div>

          <div class="w-[200px]">
            <tui-input-date [formControl]="dayControl">
              Day
              <input tuiTextfieldLegacy />
            </tui-input-date>
          </div>

          <button tuiButton type="button" (click)="applyFilters()">
            Search
          </button>

          <button
            appearance="flat"
            iconStart="@tui.rotate-cw"
            tuiButton
            type="reset"
            (click)="clearFilters()"
          >
            Clear
          </button>
        </fieldset>
      </search>
    </div>
  </div>

  <!-- Past Logs Tab Content -->
  <ng-container *ngIf="activeTabIndex === 0">

    <div *ngIf="isLoading" class="h-[200px] flex justify-center items-center">
      <tui-loader />
    </div>

    <div *ngIf="!isLoading" class="w-full mt-3 overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Username</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Role</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Login Date</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Login Time</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Logout Date</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Logout Time</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Session Duration</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let s of sessions" class="hover:bg-gray-50">
            <td class="px-4 py-2 text-sm">{{ s.username }}</td>
            <td class="px-4 py-2 text-sm">{{ s.role }}</td>
            <td class="px-4 py-2 text-sm">{{ s.loginAt | date : "MMM d, y" }}</td>
            <td class="px-4 py-2 text-sm">{{ s.loginAt | date : "HH:mm:ss" }}</td>
            <td class="px-4 py-2 text-sm">
              {{ s.logoutAt ? (s.logoutAt | date : "MMM d, y") : "—" }}
            </td>
            <td class="px-4 py-2 text-sm">
              {{ s.logoutAt ? (s.logoutAt | date : "HH:mm:ss") : "—" }}
            </td>
            <td class="px-4 py-2 text-sm">
              {{ formatDuration(s.sessionDurationSec) }}
            </td>
          </tr>
          <tr *ngIf="sessions.length === 0">
            <td colspan="7" class="text-center py-8 text-gray-500">
              No login activity for this day.
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="flex justify-end items-center mt-3" *ngIf="!isLoading">
      <tui-pagination
        [index]="pageIndex - 1"
        [length]="totalPages"
        (indexChange)="onPageChange($event + 1)"
      />
    </div>
  </ng-container>

  <!-- Active Sessions Tab -->
  <ng-container *ngIf="activeTabIndex === 1">
    <div class="mt-4 text-sm text-gray-500">
      Polling every 10 seconds for currently active users.
    </div>

    <div class="w-full mt-3 overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Username</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Role</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Login Date</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Login Time</th>
            <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase">Last Seen</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr *ngFor="let s of activeSessions" class="hover:bg-gray-50">
            <td class="px-4 py-2 text-sm">{{ s.username }}</td>
            <td class="px-4 py-2 text-sm">{{ s.role }}</td>
            <td class="px-4 py-2 text-sm">{{ s.loginAt | date : "MMM d, y" }}</td>
            <td class="px-4 py-2 text-sm">{{ s.loginAt | date : "HH:mm:ss" }}</td>
            <td class="px-4 py-2 text-sm">{{ s.lastSeenAt | date : "HH:mm:ss" }}</td>
          </tr>
          <tr *ngIf="activeSessions.length === 0">
            <td colspan="5" class="text-center py-8 text-gray-500">
              No users are currently active.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</section>
